<template>

    <nav class="bg-white shadow dark:bg-gray-800">
        <div class="hidden md:px-3 xl:container xl:px-6 pt-4 mx-auto md:flex md:justify-between md:items-center">
            <div>
                <a class="" href="#">
                    <img class="w-48" :src="img_logo" alt="">
                </a>
            </div>
            <div>
                <a class="" href="#">
                    <img class="w-48" :src="img_logo_mvl" alt="">
                </a>
            </div>
        </div>
        <div class="px-3 md:px-3 xl:container xl:px-6 py-4 mx-auto md:flex md:justify-between md:items-center">
            <div class="flex items-center justify-between">
               
                <!-- Mobile menu button -->
                <div class="flex md:hidden">
                    <button @click="isOpen = !isOpen" type="button" class="text-gray-500 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 focus:outline-none focus:text-gray-600 dark:focus:text-gray-400" aria-label="toggle menu">
                        <svg viewBox="0 0 24 24" class="w-6 h-6 fill-current">
                            <path fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"></path>
                        </svg>
                    </button>
                </div>
                <div class="md:hidden">
                    <a class="" href="#">
                        <img class="w-44" :src="img_logo" alt="">
                    </a>
                </div>
                <div class="md:hidden">
                    <a class="" href="#">
                        <img class="w-40" :src="img_logo_mvl" alt="">
                    </a>
                </div>

            </div>

            <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
            <div :class="isOpen ? '' : 'hidden'" class="items-center md:flex w-full">
                <ul class="flex flex-col md:flex-row md:mx-6 md:ml-10 md:w-full md:justify-between">
                    <li class="mr-4 py-4 "><router-link class="hover:text-theme-sky" to="/" active-link="activo">Inicio</router-link></li>
                    <li class="mr-4 py-4 "><router-link class="hover:text-theme-sky" to="/bibliotecas" active-link="activo">Red de Bibliotecas</router-link></li>
                    <li class="mr-4 py-4 "><router-link class="hover:text-theme-sky" to="/catalogo">Catálogo Colectivo</router-link></li>
                    <li class="mr-4 py-4 "><router-link class="hover:text-theme-sky" to="/autores">Autores Locales</router-link></li>
                    <li class="mr-4 py-4 "><router-link class="hover:text-theme-sky" to="/libros-circulan">Los Libros Circulan</router-link></li>
                    <li class="mr-4 py-4 "><router-link class="hover:text-theme-sky" to="/catalogos-digitales">Recursos Digitales</router-link></li>                    
                    <Menu v-if="menuItems.length > 0"  as="div" class="relative inline-block text-left py-4">
                        <div>
                          <MenuButton class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 text-gray-900 ">
                            {{ tituloNovedades }}
                            <ChevronDownIcon class="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                          </MenuButton>
                        </div>
                    
                        <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                          <MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div class="py-1">
                              <MenuItem v-for="item in menuItems" :key="item.id" v-slot="{ active }" >
                                <div @click="redirectMenu(item.slug)" 
                                   :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2']">{{item.name}}</div>
                              </MenuItem>                              
                            </div>
                          </MenuItems>
                        </transition>
                      </Menu>

                </ul>
            </div>
        </div>
    </nav>

</template>
<script>

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'    

export default ({

    props: {
        menuItems: Object,
        tituloNovedades: String
    },  

    components: {
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ChevronDownIcon
    },
    name: 'Navbar',
    setup() {
        const img_logo    = require('@/assets/images/logo_red.png')
        const img_logo_mvl = require('@/assets/images/logo_mvl.png')
        return {img_logo, img_logo_mvl}
    },
    data(){
        return{
        isOpen: false,
        }
    },

    methods: {
        redirectMenu(menu) {
            console.log(menu);
                    
            const currentPath = this.$route.path;
            // Verifica si ya estás en la página de novedades
            if (currentPath === '/novedades') {
                // this.$router.replace({ path: '/novedades', query: { filter: menu } });
                // 
                window.location.href = '#/novedades?filter=' + menu;
                window.location.reload();
            } else {
                // Si no estás en novedades, realiza la redirección normalmente
                this.$router.push({ path: '/novedades', query: { filter: menu } });
            }
        }
    }   
})
</script>
